var map = {
	"./en": 545,
	"./en.js": 545,
	"./ru": 546,
	"./ru.js": 546
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 909;



//////////////////
// WEBPACK FOOTER
// ./src/data/messages ^\.\/.*$
// module id = 909
// module chunks = 114276838955818